import { connect } from 'react-redux';
import { isFromMobileApp } from '@app/components/purchase_flow/utils/paymentSupportUtils';
import SmartBanner from './smart_banner';
import { updateSmartBannerVisibility } from '../../../actions/application';
import { getUserMatchUpBonusInfo } from '../../../config/util';

const mapStateToProps = ({
  user: { user }, homePage, application
}) => {
  const channelKey = application.dynamicConfig?.zendeskSettings?.channelKey ?? null;
  const zendeskJwt = user?.zendeskConfig?.jwtToken ?? '';
  const zendeskMessengerLikelyVisible = !!(channelKey && zendeskJwt && !isFromMobileApp());

  return {
    hasOrders: !!((user || {}).numberOfChatOrders || (user || {}).numberOfVcOrders
    || (user || {}).numberOfVoiceCallOrders),
    promoBannerIsOn: !!((homePage.salesBanner || {}).content),
    smartBannerVisible: application.smartBannerVisible,
    userShowMatchUpBonusInfo: user && user.showMatchUpBonusInfo,
    userLoading: false,
    promo: application.dynamicConfig?.promo,
    matchUpBonusInfo: getUserMatchUpBonusInfo({ bonusInfos: user && user.bonusInfos }) ?? application.dynamicConfig?.matchUpBonusInfo,
    url: application.dynamicConfig?.url,
    zendeskMessengerLikelyVisible
  };
};

export default connect(
  mapStateToProps,
  {
    updateSmartBannerVisibility
  }
)(SmartBanner);
